import React from "react";
import { Navigate } from "react-router-dom";

const isAuthenticated = () => {
  const token = sessionStorage.getItem("accessToken");
  return !!token; // Returns true if token exists, false otherwise
};

const ProtectedRoute = ({ element: Element }) => {
  return isAuthenticated() ? <Element /> : <Navigate to="/" />;
};

export default ProtectedRoute;
